import { CommonModule } from '@angular/common';
import { Compiler, Component, NgModule, OnInit, ViewChild, ViewContainerRef, SecurityContext } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { ModalModule, ModalDirective } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';

import { AppComponent } from '../../app.component';
import { SignUpMainComponent } from './sign-up-main.component';
import { SignUpService } from '../../service/sign-up.service';
import { WebApiService } from '../../service/web-api.service';
import { DisplayService } from '../../service/display.service';
import { CheckItemService } from '../../service/checkItem.service';
import { CustomViewService } from '../../service/custom-view.service';
import { DocumentService } from '../../service/document.service';
import { AuthService } from '../../service/auth.service';
import { MfaTelephoneService } from '../../service/mfa-telephone.service';

import { WaitModalComponent } from '../wait-modal/wait-modal.component';
import { environment } from '../../../environments/environment';

import { DocumentModalComponent } from '../document-modal/document-modal.component';
import { DomSanitizer } from '@angular/platform-browser';
import { MfaTelephoneModalComponent } from '../mfa-telephone-modal/mfa-telephone-modal.component';

declare let gtag: any; // グローバル変数gtagを解決

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  providers: [WebApiService, SignUpService, CheckItemService, CustomViewService, DocumentService, MfaTelephoneService]
})
export class SignUpComponent implements OnInit {

  constructor(private compiler: Compiler, private customViewService: CustomViewService,
    private signUpService: SignUpService, private appComponent: AppComponent,
    private displayService: DisplayService, private checkItemService: CheckItemService,
    private documentService: DocumentService, private mfaTelephoneService: MfaTelephoneService,
    public router: Router, private authService: AuthService, private activatedRoute: ActivatedRoute,
    private sanitizer: DomSanitizer) { }

  @ViewChild('waitModal', { static: false }) waitModal: WaitModalComponent;
  @ViewChild('documentModal', { static: false }) documentModal: DocumentModalComponent;
  @ViewChild('mfaTelephoneModal', { static: false }) mfaTelephoneModal: MfaTelephoneModalComponent;

  // 画面ID
  readonly SCREEN_ID = 'O02';

  // タイトルロゴ
  public dispZ0001: string;
  // アカウント作成時のメッセージ
  public dispO0201: string;

  // ページ番号定義
  public pageNo: number;
  // 操作クラス定義
  public comp: SignUpMainComponent;

  // テンプレートファイ名（HTML）
  public templateHtml: string;
  // テンプレートファイル（CSS）
  public templateCss: string;
  // 画面資材ルートURL
  public assetsBaseUrl: string;
  // 共通画面資材URL
  public assetsPortalBaseUrl: string;
  // サービス名
  public serviceName: string;

  // 画面項目定義
  public email: string;
  public userId: string;
  public password: string;
  public confirmPassword: string;
  public consentDisabled: boolean;
  public extensionConsent: boolean;
  public birthdate: string;
  public birthdateYear: string;
  public birthdateMonth: string;
  public birthdateDay: string;
  public familyName: string;
  public givenName: string;
  public phoneNumber: string;
  public documentInfoList: any[];

  public emailDisabled: boolean;
  public userIdDisabled: boolean;
  public birthdateDisabled: boolean;
  public familyNameDisabled: boolean;
  public givenNameDisabled: boolean;
  public phoneNumberDisabled: boolean;
  public isMfaPage: boolean;
  public mfaRequired: boolean;
  public countResult: boolean;
  public haveEnoughConditions: boolean;

  @ViewChild('dest', { read: ViewContainerRef, static: false })
  public dest: ViewContainerRef;

  async ngOnInit() {
    // ページ番号をURLより取得
    const urlPageNo = +this.activatedRoute.snapshot.params['pageNo'];

    if (this.appComponent.dispZ0000 === undefined) {
      await this.appComponent.getDisplayInfo();
    }
    // 読み込まれるHTML名の取得
    this.serviceName = '';
    if (this.appComponent.dispZ0000 === '') {
      this.serviceName = 'portal';
    } else {
      this.serviceName = this.appComponent.dispZ0000;
    }
    this.assetsBaseUrl = environment.storageBaseUrl + '/' + this.serviceName + '/adume';
    this.assetsPortalBaseUrl = environment.storageBaseUrl + '/portal';
    this.templateHtml = this.assetsBaseUrl + '/html/sign-up/' + this.serviceName + '_sign-up';
    this.templateCss = this.assetsBaseUrl + '/css/' + this.serviceName + '_sign-up.css';

    // 画面カスタマイズ情報
    await this.displayService.execAuthDisplayInfo(this.SCREEN_ID).subscribe(data => {
      this.dispZ0001 = '';
      this.dispO0201 = '';
      if (data.displayInfo != null) {
        if (data.displayInfo.Z0001 != null) {
          this.dispZ0001 = data.displayInfo.Z0001;
        }
        if (data.displayInfo.O0201 != null) {
          this.dispO0201 = data.displayInfo.O0201;
        }
      }

      // 初期値設定
      this.pageNo = 1;

      this.email = '';
      this.userId = '';
      this.birthdate = '';
      this.birthdateYear = '';
      this.birthdateMonth = '';
      this.birthdateDay = '';
      this.familyName = '';
      this.givenName = '';
      this.phoneNumber = '';
      this.password = '';
      this.confirmPassword = '';
      this.consentDisabled = true;
      this.extensionConsent = false;
      this.emailDisabled = false;
      this.userIdDisabled = false;
      this.birthdateDisabled = false;
      this.familyNameDisabled = false;
      this.givenNameDisabled = false;
      this.phoneNumberDisabled = false;
      this.mfaRequired = false;
      this.haveEnoughConditions = false;
      this.countResult = false;

      // 引継ぎパラメータを設定
      if (data.initParameter != null) {
        if (!isNaN(urlPageNo)) { this.pageNo = urlPageNo; }

        if (data.initParameter.email != null) {
          this.email = data.initParameter.email.value;
          this.emailDisabled = data.initParameter.email.fixed;
        }
        if (data.initParameter.name != null) {
          this.userId = data.initParameter.name.value;
          this.userIdDisabled = data.initParameter.name.fixed;
        }
        if (data.initParameter.family_name != null) {
          this.familyName = data.initParameter.family_name.value;
          this.familyNameDisabled = data.initParameter.family_name.fixed;
        }
        if (data.initParameter.given_name != null) {
          this.givenName = data.initParameter.given_name.value;
          this.givenNameDisabled = data.initParameter.given_name.fixed;
        }
        if (data.initParameter.phone_number != null) {
          this.phoneNumber = data.initParameter.phone_number.value;
          this.phoneNumberDisabled = data.initParameter.phone_number.fixed;
        }

        if (data.initParameter.birthdate != null) {
          this.birthdate = data.initParameter.birthdate.value;
          this.birthdateDisabled = data.initParameter.birthdate.fixed;

          if (!isNaN(urlPageNo)) {
            // ページ番号指定があった場合は、前画面からの引継ぎと判断し引継ぎ情報の値をそのまま詰める
            if (data.initParameter.birthdate_year != null) { this.birthdateYear = data.initParameter.birthdate_year; }
            if (data.initParameter.birthdate_month != null) { this.birthdateMonth = data.initParameter.birthdate_month; }
            if (data.initParameter.birthdate_day != null) { this.birthdateDay = data.initParameter.birthdate_day; }
          } else {
            // ページ番号指定が無かった場合は、Fintechからの引継ぎと判断しbirtdateの値を分割し詰める
            const arrayBirth = this.birthdate.split('-');
            this.birthdateYear = arrayBirth[0];
            this.birthdateMonth = arrayBirth[1];
            this.birthdateDay = arrayBirth[2];
          }
        }

        if (data.initParameter.password != null) { this.password = data.initParameter.password; }
        if (data.initParameter.confirm_password != null) { this.confirmPassword = data.initParameter.confirm_password; }
        if (data.initParameter.consent_disabled != null) { this.consentDisabled = data.initParameter.consent_disabled; }
        if (data.initParameter.extension_consent != null) { this.extensionConsent = data.initParameter.extension_consent; }
        if (data.initParameter.document_info_list != null) { this.documentInfoList = data.initParameter.document_info_list; }
      }

      if (data.mfaRequired != null) { this.mfaRequired = data.mfaRequired; }

      // 書面確認をしていない場合、未読書面情報を取得
      if (this.consentDisabled) {
        this.documentService.execAuthGetUnreadDocument().subscribe(documentData => {
          this.documentInfoList = documentData.documentInfoList;
          if (this.documentInfoList == null) {
            this.documentInfoList = [];
          }

          // 規約埋め込み（iframe）時にunsafeなURLとしてエラーとなるのでURLを無害化しておく
          for (const doc of this.documentInfoList) {
            const sanitizedDocumentUrl = this.sanitizer.sanitize(SecurityContext.URL, doc.url);
            doc.url = this.sanitizer.bypassSecurityTrustResourceUrl(sanitizedDocumentUrl);
          }

          this.directInjection();
        });
      } else {
        // カスタムページ表示
        this.directInjection();
      }
    });
  }

  /**
   * コンポーネントを生成し親コンポーネントに挿入する
   *
   */
  public async directInjection() {

    gtag('config', environment.analyticsId, {
      'page_path': '/html/sign-up/' + this.serviceName + '_sign-up' + '/' + this.pageNo,
      'page_title': 'sign-up',
    });

    gtag('config', environment.analyticsIdGa4, {
      'page_title': 'sign-up',
      'page_location': this.serviceName + '/sign-up/' + this.pageNo
    });

    // 元の要素をクリアする
    this.dest.clear();

    // テンプレートを取得
    let templateHtmlText = await this.customViewService.getText(this.templateHtml + '_' + this.pageNo + '.html').toPromise();
    let templateCssText = await this.customViewService.getText(this.templateCss).toPromise();
    templateCssText = templateCssText.replace(/{{assetsBaseUrl}}/g, this.assetsBaseUrl);
    templateHtmlText = templateHtmlText.replace(/{{assetsBaseUrl}}/g, this.assetsBaseUrl);
    templateHtmlText = templateHtmlText.replace(/{{assetsPortalBaseUrl}}/g, this.assetsPortalBaseUrl);

    // Angular コンポーネントを用意する
    @Component({
      selector: 'app-sign-up-main',
      template: templateHtmlText,
      styles: [templateCssText],
    })

    class SignUpModuleComponent extends SignUpMainComponent { }
    // Angular モジュールを用意する

    @NgModule({
      imports: [CommonModule, FormsModule, PopoverModule.forRoot()],
      declarations: [SignUpModuleComponent],
      exports: [SignUpModuleComponent]
    })
    class SignUpModule {
    }

    // Angular モジュールとコンポーネントをコンパイルする
    const module = this.compiler.compileModuleAndAllComponentsSync(SignUpModule);
    // Angular モジュールから SignUpModuleComponent を生成するファクトリを取り出す
    const factory = module.componentFactories.find((c) => {
      return c.componentType === SignUpModuleComponent;
    });

    // SignUpModuleComponent を生成し this.dest に設定する
    const componentRef = this.dest.createComponent(factory);

    // componentのインスタンスを取得する。
    this.comp = (<SignUpModuleComponent>componentRef.instance);
    this.comp.init(this, this.signUpService, this.checkItemService, this.waitModal,
      this.authService, this.documentService, this.mfaTelephoneService, this.documentModal, this.mfaTelephoneModal);
  }
}
